import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "@/components/site/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export function Ancestry() {
  const { t } = useLanguage();

  return (
    <section data-testid="ancestry-section" className="relative overflow-hidden bg-clan-bg py-28 lg:py-40">
      {/* Kinetic outline marquee behind content */}
      <div className="pointer-events-none absolute inset-0 flex flex-col justify-center gap-4 opacity-70">
        <Marquee speed={26} gradient={false}>
          <span className="text-stroke whitespace-nowrap font-serif text-[10rem] font-bold leading-none lg:text-[16rem]">
            {t.ancestry.marquee}
          </span>
        </Marquee>
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-6 text-center lg:px-10">
        <Reveal>
          <div className="flex justify-center">
            <Overline>{t.ancestry.overline}</Overline>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-5xl font-light tracking-tight text-clan-ink sm:text-6xl lg:text-7xl pearl">
            {t.ancestry.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-clan-muted">{t.ancestry.body}</p>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            href="#join"
            data-testid="ancestry-cta"
            className="mt-10 inline-block rounded-md border border-clan-accent bg-clan-accent/10 px-8 py-3.5 font-mono text-xs uppercase tracking-widest text-clan-accent backdrop-blur-sm transition-colors duration-300 hover:bg-clan-accent hover:text-black focus:outline-none focus:ring-2 focus:ring-clan-accent"
          >
            {t.ancestry.cta}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
